import gql from 'graphql-tag';

export const CERTIFICATION_PROJECT_FRAGMENT = gql`
  fragment CertificationProject on CertificationProject {
    id
    certificationId
    certification {
      name
    }
    createdOn
    deletedOn
    projectId
  }
`;
